module.exports = __webpack_public_path__ + "static/media/advanced-option.c294df00.jpg";